export const SITE = {
  brand: "Clínica Vida Saudável",
  professional: "Osvaldo Alves",
  role: "Quiropraxista • Especialista em Coluna",
  crt: "CRT 47010",
  rating: 4.9,
  reviewsCount: 30,
  phone: "(22) 99880-0104",
  whatsappRaw: "5522998800104",
  whatsappLink: "https://wa.me/5522998800104?text=Ol%C3%A1!%20Vim%20atrav%C3%A9s%20do%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es.",
  website: "osvaldoalvesquiroprata.com.br",
  address: {
    street: "Av. Henrique Terra, 48",
    district: "Portinho",
    city: "Cabo Frio",
    state: "RJ",
    zip: "28915-115",
    full: "Av. Henrique Terra, 48 - Portinho, Cabo Frio - RJ",
  },
  hours: [
    { day: "Segunda a Sexta", time: "09:00 – 17:00" },
    { day: "Sábado e Domingo", time: "Fechado" },
  ],
  mapsEmbed:
    "https://www.google.com/maps?q=Av.%20Henrique%20Terra%2C%2048%20-%20Portinho%2C%20Cabo%20Frio%20-%20RJ&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Av.+Henrique+Terra%2C+48+-+Portinho%2C+Cabo+Frio+-+RJ",
};

export const PHOTOS = {
  heroAdjust: "https://customer-assets.emergentagent.com/job_clinica-vida-rv/artifacts/g0n3w07e_odskf.jpeg",
  greenOffice: "https://customer-assets.emergentagent.com/job_clinica-vida-rv/artifacts/lox1gt3x_fsdfs.jpeg",
  facade: "https://customer-assets.emergentagent.com/job_clinica-vida-rv/artifacts/1rmya7vu_ok.jpeg",
  turquoiseTable: "https://customer-assets.emergentagent.com/job_clinica-vida-rv/artifacts/0akp20nr_fghfg.jpeg",
  tractionTable: "https://customer-assets.emergentagent.com/job_clinica-vida-rv/artifacts/hezq00s7_WhatsApp%20Image%202026-05-06%20at%2009.30.26.jpeg",
};

// YouTube IDs for placeholder (chiropractic/quiropraxia content)
export const VIDEO_TESTIMONIALS = [
  {
    id: "v1",
    name: "Felipe Da Silva",
    when: "2 meses atrás",
    rating: 5,
    quote:
      "O atendimento do Bruno é impecável... saio renovado a cada sessão. Profissionalismo do início ao fim.",
    youtubeId: "yvg3TsxAvNw",
    thumb: `https://img.youtube.com/vi/yvg3TsxAvNw/hqdefault.jpg`,
  },
  {
    id: "v2",
    name: "Erly Penha de Almeida",
    when: "1 ano atrás",
    rating: 5,
    quote:
      "Conheci Sr. Osvaldo e Janaína. Após 10 sessões, não precisei mais de medicamento. Mudou minha vida.",
    youtubeId: "WCQUTFdb3iY",
    thumb: `https://img.youtube.com/vi/WCQUTFdb3iY/hqdefault.jpg`,
  },
  {
    id: "v3",
    name: "Robson Eloi",
    when: "1 ano atrás",
    rating: 5,
    quote:
      "Cheguei com dor severa na coluna. Após 10 sessões, voltei à minha rotina e aos esportes. Recomendo!",
    youtubeId: "OmS9_qq4XLo",
    thumb: `https://img.youtube.com/vi/OmS9_qq4XLo/hqdefault.jpg`,
  },
  {
    id: "v4",
    name: "Marina S.",
    when: "8 meses atrás",
    rating: 5,
    quote:
      "Super recomendo, profissionais atenciosos e ambiente acolhedor. Saí da primeira sessão renovada.",
    youtubeId: "v1xT5K1V_2g",
    thumb: `https://img.youtube.com/vi/v1xT5K1V_2g/hqdefault.jpg`,
  },
  {
    id: "v5",
    name: "Carla R.",
    when: "5 meses atrás",
    rating: 5,
    quote:
      "Janaína fora do normal! Equipe nota 1000. Atendimento humano que faz toda a diferença.",
    youtubeId: "kCkt2bQ2lWQ",
    thumb: `https://img.youtube.com/vi/kCkt2bQ2lWQ/hqdefault.jpg`,
  },
  {
    id: "v6",
    name: "Paulo F.",
    when: "1 ano atrás",
    rating: 5,
    quote:
      "Escapei de uma cirurgia na coluna. Tratamento sério, baseado em evidência e muito carinho.",
    youtubeId: "vYbXy3J0sYI",
    thumb: `https://img.youtube.com/vi/vYbXy3J0sYI/hqdefault.jpg`,
  },
];

export const REVIEW_DISTRIBUTION = [
  { stars: 5, count: 27 },
  { stars: 4, count: 2 },
  { stars: 3, count: 1 },
  { stars: 2, count: 0 },
  { stars: 1, count: 0 },
];

export const REVIEW_TAGS = [
  "Cirurgia evitada",
  "Equipe acolhedora",
  "Quiropraxia",
  "Dor de coluna",
  "Atendimento humano",
  "Resultado rápido",
  "Profissionalismo",
];

export const SERVICES = [
  {
    title: "Quiropraxia para Coluna",
    icon: "Activity",
    desc: "Ajustes manuais precisos para alívio de dores na coluna, hérnias de disco, ciática e tensões musculares. Atendimento individualizado para cada paciente.",
    image: "tractionTable",
  },
  {
    title: "Quiropraxia Tradicional Chinesa",
    icon: "Sparkles",
    desc: "Técnica milenar focada exclusivamente no realinhamento da coluna e desbloqueio de articulações para aliviar dores crônicas e recuperar a mobilidade.",
    image: "turquoiseTable",
  },
  {
    title: "Tratamento de Dores na Coluna",
    icon: "Leaf",
    desc: "Programa completo para dores cervicais, dorsais e lombares — combinando ajustes, alongamento e orientação postural para resultados duradouros.",
    image: "greenOffice",
  },
];
